<template>
  <div class="inspection-detail-report">
    <InspectionDetailReportDoc
      ref="reportDoc"
      :inspectionApplyCode="inspectionApplyCode"
      :disabled="disabled"
    />
    <InspectionDetailReportProductDetailImage
      ref="productDetailImage"
      :inspectionApplyCode="inspectionApplyCode"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import InspectionDetailReportDoc from './doc/index.vue'
import InspectionDetailReportProductDetailImage from './product-detail-image/index.vue'

export default {
  name: 'InspectionDetailReport',
  components: {
    InspectionDetailReportDoc,
    InspectionDetailReportProductDetailImage,
  },
  props: {
    inspectionApplyCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    refreshData() {
      this.$refs.reportDoc?.loadDocList?.()
      this.$refs.productDetailImage?.loadProductPhotos?.()
    },
  },
}
</script>

<style lang="scss" scoped>
.inspection-detail-report {
  padding: 4px 0;
}
</style>
